import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface LoaderState {
  show: boolean;
}

@Injectable( {
  providedIn: 'root'
} )
export class SharedService {
  loaderSubject = new BehaviorSubject<LoaderState>( { show: false } );

  constructor() {
  }

  showLoader(): void {
    this.loaderSubject.next( {show: true} );
  }

  hideLoader(): void {
    this.loaderSubject.next( {show: false} );
  }
}
